import { PauseCircleOutlined } from "@ant-design/icons"
import { getApiErrorMessage } from "@timenotes/shared/src/services/api-client"
import useStopUserTrackerMutation from "@timenotes/shared/src/services/timer/queries/use-stop-user-tracker-mutation"
import { message } from "antd"
import { COLORS } from "components/layout-components/timenotes-theme"
import { useQueryClient } from "react-query"
import styled from "styled-components"

interface Props {
  trackerId: string
}

export function PauseActiveTrackerIcon(props: Props) {
  const {
    trackerId
  } = props

  const queryClient = useQueryClient()

  const stopUserTrackerMutation = useStopUserTrackerMutation({
    trackerId,
    options: {
      onError: (error: any) => {
        if (error.status == 404) {
          message.error("This tracker is no longer running!")
          queryClient.invalidateQueries('activities', { exact: false })
        } else {
          message.error(getApiErrorMessage(error, 'base'))
        }
      }
    }
  })

  return (
    <PauseIcon 
      onClick={() => stopUserTrackerMutation.mutate()}
    />
  )

}

const PauseIcon = styled(PauseCircleOutlined)`
  cursor: pointer;

  :hover {
    color: ${COLORS.primaryGreen}
  }
`